module.exports = __webpack_public_path__ + "img/tavuklu ramen.43a70bdf.png";